import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useRegisterContext } from "../../Contexts/RegisterContext";
import InputField from "../../Components/InputField";
import ErrorModal from "../../Components/ErrorModal";
import Button from "../../Components/Button";

function CardDetailsDelivery() {
  const {
    setDisplayAlert,
    setAlertMessage,
    displayAlert,
    isEmailValid,
    alertMessage,
    handleEmail,
    setEmail,
    navigate,
    email,
  } = useRegisterContext();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setDisplayAlert(false);
  };

  const handleBack = () => {
    navigate("/activate/success");
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-center justify-center cursor-default">
      <div className="w-full sm:w-148 flex-grow">
        <div className="sm:w-148 bg-white rounded-xl sm:mt-24">
          <div className="grid grid-cols-1 divide-y">
            <div className="p-4">
              <KeyboardArrowLeftIcon
                className="absolute cursor-pointer"
                onClick={handleBack}
              />
              <div className="text-center font-semibold text-[#1F2328]">
                Card Details Delivery
              </div>
            </div>
            <div className="p-6">
              <div className="w-full text-[#60656D]">
                Receive your Maxicare Account details in your inbox. Just enter
                your email below
              </div>
              <div className="font-medium mt-2">Email</div>
              <div className="mt-1">
                <InputField
                  id="email"
                  maxLength="50"
                  placeholder="example@email.com"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setAlertMessage("");
                  }}
                  error={alertMessage}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      handleEmail();
                    }
                  }}
                />
                <span className="text-sm text-[#D32F2F]">{alertMessage}</span>
              </div>
              <div className=" justify-end sm:px-0 sm:w-full relative p-2 inset-x-0 bottom-0 sm:relative mt-2">
                <Button
                  disabled={!isEmailValid}
                  className={`w-full h-12 rounded-xl font-semibold ${
                    !isEmailValid
                      ? `text-[#A3A7AB] bg-[#F6F7F7]`
                      : `text-white transition ease-in-out delay-75 hover:scale-105 mb-2`
                  }`}
                  onClick={handleEmail}
                >
                  Send details and verify email
                </Button>
                <Button
                  className="w-full h-12 mt-2 text-[#383F49] bg-white border border-[#D6D7D8] rounded-xl font-semibold transition ease-in-out delay-75 hover:scale-105"
                  onClick={() => navigate("/home")}
                >
                  Skip
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorModal
        open={displayAlert}
        title={"Oops! No enrolled member found"}
        message={
          "The system couldn't find any enrolled member with the provided details. Please double-check and try again."
        }
        onClose={handleClose}
      />
    </div>
  );
}

export default CardDetailsDelivery;
